import React from "react";
import "./styles.css";

const ButtonsGroup = ({ options, selected, userId, onChange }) => (
  <div className="buttons-group-wrapper">
    {
      options?.map(option => {
        const selectedClass = option?.value === selected ? "buttons-group-selected" : "";

        return (
          <div
            data-value={option?.value}
            data-name={option?.name}
            className={`${selectedClass} buttons-group-button`}
            onClick={e => onChange(e.target.getAttribute("data-value"), userId)}
          >
            {option?.name}
          </div>
        );
      })
    }
  </div>
);

export default ButtonsGroup;
